import setDeviceId from 'root/src/client/logic/app/actions/setDeviceId'

export default deviceId => (dispatch) => {
	dispatch(setDeviceId(deviceId))
}
